<div class="pps-container" 
     [class.development]="isLocalOrDevelopment"
     [class.test]="isTest"
     [class.production]="isProduction">
    <pps-nav-menu></pps-nav-menu>
    <div class="pps-body">
      <router-outlet></router-outlet>
    </div>
</div>

<div *ngIf="appLoadingStatus === AppStatus.UserContextLoading" class="pps-container" >
  <ngx-spinner bdColor="rgba(0, 0, 128, 0.8)"
               size="large"
               color="#2f9cf2"
               type="ball-scale-ripple-multiple"
               [name]="spinnerName"
               [fullScreen]="false">
    <p style="color:white;font-size:18px;" >{{appLoadingStatusMsg}}</p>
  </ngx-spinner>
</div>